<template>
  <span>
    <Button>Hello World</Button>
  </span>
</template>

<script>
import Button from "@/components/Button.vue";

export default {
  name: "HomeView",
  props: {},
  components: { Button },
};
</script>

<style scoped></style>
